import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './pig.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export function PigIcon(props: IconProps) {
  return <Icon className={props.className} />;
}
